import React from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Popover from '@mui/material/Popover';

export default function Popup({children,target=null,close, placement="bottom",key=1}){
  const open = Boolean(target);
  const id = open ? 'simple-popover' : undefined;
  const handleClose = () => {
    target=null
  };
    return(
      <Popover onClose={close} key={key} open={target!=null} anchorEl={target} placement={placement}>
        <Paper style={{borderRadius:"10px",boxShadow: "0px 3px 6px #00000029"}}>
          {children}
        </Paper>
      </Popover>
    )
  }